<template>
  <el-popover
    placement="bottom"
    class="table-select-box"
    v-if="onlyValue"
    :class="{'show-txt-rest':readonly,'blur-border': isShow,'visible-onlyValue': fileList && fileList.length > 0}"
    ref="popover"
    style="width:100%;height: 100%;"
    v-model="isShow"
    @click.native="uploadCurr"
    trigger="manual">
    <upload :readonly="readonly" ref="uploadm" :config="config" v-model="fileList" @change="handleSuccess" @remove="removeFile" @uploading="uploadNow" :isOpend="isOpend" :item="item" :onlyValue="onlyValue"></upload>
    <div class="custom-upload" slot="reference">
      <div
        class="attachment-item"
        @click="attachClickTable(fileList[0])"
        v-if="fileList && fileList.length > 0"
      >
        <div class="img-item" style="width:100%">
          <img style="width:16px;height:16px;margin-right:4px;" :src="getIconType(fileList[0].attachment_type)" alt="">
          <span>{{fileList[0].attachment_name}}</span>
        </div>
      </div>
      <p v-else class="table-select-button" style="width:100%;height: 100%;">
        <span v-if="readonly">-</span>
        <span v-else><i class="el-icon-circle-plus"></i>添加</span>
      </p>
    </div>
  </el-popover>
  <div v-else-if="(fileList && fileList.length > 0) || !readonly" class="rest-form-item">
    <div class="custom-upload">
      <div class="upload-content" :class="{'custom-upload-rest':!isOpend}">
        <upload :readonly="readonly" ref="uploadm" :config="config" v-model="fileList" @change="handleSuccess" @remove="removeFile" :isOpend="isOpend" :item="item" ></upload>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import {
  Cookie,
  Storage
} from '@/utils/utils';
import axios from 'axios';
import upload from './upload'
import projectConfig from '@config/projectConfig'
import downApi from '@/services/api/downFile'
export default {
  name: "Attachment",
  props: ['value', 'config', 'defaultValue', 'onlyValue', 'item', 'getketText', 'readonly', 'isTemplate'],
  components: {
    upload
  },
  data() {
    return {
      fileList: [],
      uploadingList: [],
      sorrt: false,
      isOpend: true,
      rojectConfig: projectConfig,
      fileIcon: [
        {
          icon: '/image/icon/icon_mp4_annex.png',
          list: 'mp4,avi,flv,wav,mov,mpeg,dat,mpg'
        },
        {
          icon: 'image/icon/icon_doc_annex.png',
          list: 'doc,docx,text'
        }, {
          icon: 'image/icon/icon_gif_annex.png',
          list: 'gif'
        }, {
          icon: 'image/icon/icon_jpg_annex.png',
          list: 'jpg,jpeg,png,bmp,svg'
        }, {
          icon: 'image/icon/icon_xls_annex.png',
          list: 'xls,xlsx'
        }, {
          icon: 'image/icon/icon_ppt_annex.png',
          list: 'ppt,pptx'
        }, {
          icon: 'image/icon/icon_pdf_annex.png',
          list: 'pdf'
        }
      ],
      isShow: false,
      isUploading: false
    }
  },
  watch: {
    fileList() {
      this.$emit('input', this.isTemplate ? this.fileList : this.fileList.map(res => res.attachment_sign))
    }
  },
  computed: {
    headers() {
      return { 'X-TOKEN': Storage.get('wfUserInfo').token }
    },
    firstItem() {
      return this.fileList && this.fileList.length > 0 ? this.fileList.slice(0, 1)[0] : ''
    }
  },
  created() {
    this.init()
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
  },
  beforeDestroy() {
     document.removeEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    ...mapActions('task/task', ['editTask']),
    bodyCloseMenus(e) {
      if (this.$refs.popover && this.$refs.popover.$el && !this.$refs.popover.$el.contains(e.target)) {
        if (this.isShow == true) {
          this.isShow = false
        }
      }
    },
    uploadCurr() {
      if(this.readonly) return
      if(this.fileList.length === 0 && !this.isUploading) {
        this.$refs.uploadm.emitUpload();
      } else {
        console.log('asdsad', this.isShow)
        this.isShow = !this.isShow
      }
    },
    init() {
      if (this.defaultValue && this.defaultValue.length > 0) {
        this.fileList = this.defaultValue.map(res => res.attachment || res)
      }
    },
    getMessage(res) {
      if (res.add_data.length > 0 && res.delete_data.length > 0) {
        return `
        <span class="message-mixin-tip">${res.field_name}上传了</span>
        <span class="message-mixin-task message-mixin-file">
            ${res.add_data.map(res => `"${this.fileSuffix(res.attachment_name)}"`).join('、')}
        </span>,
        <span class="message-mixin-tip">${res.field_name}删除了</span>
        <span class="message-mixin-task message-mixin-file">${res.delete_data.map(res => `"${this.fileSuffix(res.attachment_name)}"`).join('、')}</span>`
      } else if (res.add_data.length > 0) {
        return `
        <span class="message-mixin-tip">${res.field_name}上传了</span>
        <span class="message-mixin-task message-mixin-file">${res.add_data.map(res => `"${this.fileSuffix(res.attachment_name)}"`).join('、')}</span>`
      } else if (res.delete_data.length > 0) {
        return `
        <span class="message-mixin-tip">${res.field_name}删除了</span>
        <span class="message-mixin-task message-mixin-file">${res.delete_data.map(res => `"${this.fileSuffix(res.attachment_name)}"`).join('、')}</span>`
      }
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val.map(res => res.attachment.attachment_sign)
      }
    },
    getIconType(type) {
      // let item = this.fileIcon.find(res => res.list.indexOf(type) > -1)
      // return item ? item.icon : 'image/icon/icon_doc_annex.png'
      // let type = file.uid ? file.name.substr(file.name.lastIndexOf(".") + 1) : file.attachment_type
      return this.getFileTypeUrl(type)
    },
    handleSuccess({ file }) {
      // let idx = 0
      // this.uploadingList.find((res, index) => {
      //   if (res.attachment_name === file.attachment_name) {
      //     idx = index
      //     return true
      //   }
      // })
      // this.uploadingList.splice(idx, 1)
      this.fileList.push({
        attachment_name: file.attachment_name,
        attachment_link: file.attachment_link,
        attachment_sign: file.attachment_sign,
        attachment_type: file.attachment_type,
        attachment_size: file.attachment_size,
        oss_attachment_name: file.oss_attachment_name
      })
      this.$nextTick(() => {
        this.$emit('change', this.fileList.map(res => res.attachment_sign), this.fileList)
      })
    },
    removeFile(index) {
      this.fileList.splice(index, 1)
      this.$nextTick(() => {
        this.$emit('change', this.fileList.map(res => res.attachment_sign), this.fileList)
      })
    },
    attachmentList() {
      return this.fileList.map((item) => {
        return {
          attachment_sign: item.attachment_sign,
          attachment_type: item.attachment_type,
          attachment_size: item.attachment_size
        }
      })
    },
    attachClickTable() {
      return
      if(this.fileList.length > 1) return
      this.attachClick(this.firstItem)
    },
    attachClick(file) {
      let fl = this.isCanPreview(file.attachment_type)
      this.getOssUrl(file.oss_attachment_name, data => {
        if (fl) {
          this.opendImgUrl(file.attachment_type, data.sign_url)
        } else {
          window.open(data.sign_url)
        }
      })
    },
    targetFile(itemData) {
      window.open(itemData.attachment_link, itemData.attachment_name);
    },
    downloadFile(content, itemData, type) {
      const blob = new Blob([content], { type })
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        elink.download = itemData.attachment_name
        elink.style.display = 'none'
        elink.href = window.URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      } else { // IE10+下载
        navigator.msSaveBlob(blob, itemData.attachment_name)
      }
    },
    setScroll() {
      this.$refs.listbox ? this.$refs.listbox.scrollTop = 0 : ''
      return this.sorrt
    },
    onProgress(e, file, fileList) {
      let idx = 0
      this.uploadingList.find((res, index) => {
        if (res.attachment_name === file.name) {
          idx = index
          return true
        }
      })
      this.uploadingList[idx].percentage = e.percent
    },
    uploadNow(fl) {
      this.isUploading = fl
      if (fl) {
        this.isShow = true
      }
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.file-list-drop {
  margin-top: 8px !important;
  max-height: 400px;
  overflow-x: hidden;
}
.attachment-label {
  width: 100%;
  display: flex;
  justify-content: space-between;
  i {
    font-size: 12px;
    margin-right: 6px;
  }
  .attachment-label-right {
    .icon {
      visibility: hidden;
    }
    .iconicon_arrow_task {
      transform: rotateZ(0);
      transition: all 0.3s;
      // margin-right: 8px;
    }
    .active {
      transform: rotateZ(180deg);
    }
    i {
      cursor: pointer;
      &:hover {
        color: $colorStatus-activeColor;
      }
    }
  }
  &:hover {
    .attachment-label-right .icon {
      visibility: visible;
    }
  }
}
.attachment-item-dom {
  position: relative;
  cursor: pointer;
  display: flex;
  height: 32px;
  border-bottom: 1px solid #edeef2;
  padding: 5px 8px;
  box-sizing: border-box;
  border-radius: 4px;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  padding-right: 18px;
  margin-bottom: 6px;
  font-size: 14px;
  min-width: 65px;
  max-width: 185px;
  &:hover {
    background-color: #f3f4f5;
    .el-icon-download {
      visibility: visible;
    }
  }
  > div {
    display: flex;
    align-items: center;
  }
}
.attachment-item-dom span {
  display: block;
  max-width: 280px;
  font-size: 14px;
  @include ellipsis;
}
.attachment-item-dom > i {
  font-size: 12px;
  color: #444;
  padding: 6px;
}
.attachment-item-dom .el-icon-download {
  visibility: hidden;
}
.attachment-item-dom .iconicon_close_toast {
  margin-left: 8px;
  font-size: 16px;
  cursor: pointer;
}
.custom-upload {
  width: 100%;
  display: flex;
  padding: 0 0px;
  margin-bottom: 0px;
  align-content: center;
  align-items: flex-start;
  // align-items: center;
  .more {
    width: 20px;
    height: 20px;
    border-radius: 2px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    &:hover {
      background-color: rgba(32, 32, 32, 0.08);
      i {
        color: $color-active;
      }
    }
  }
  .upload-content {
    display: flex;
    align-content: center;
    align-items: flex-start;
    width: 100%;
  }
  .my-upload-list {
    transition: all 0.3s;
    max-height: 1000px;
  }
  .custom-upload-rest {
    .my-upload-list {
      max-height: 156px;
      overflow: hidden;
    }
  }
  .only-value {
    display: flex;
    align-items: center;
    width: 100%;
    .attachment-item {
      margin-bottom: 0;
    }
  }
  .item-tops {
    display: flex;
    padding-top: 0px;
    i {
      width: 20px;
      height: 20px;
      cursor: pointer;
      &:hover {
        color: #509aff;
      }
    }
  }
  .iconicon_annex1 {
    margin-top: 2px;
    color: #75748e;
  }
  &:hover {
    .iconicon_annex {
      color: #509aff;
    }
  }
  .attachment-list-box {
    display: flex;
    align-items: center;
    padding: 0 10px;
    padding-right: 14px;
    flex-wrap: wrap;
    max-height: 35px;
    max-width: 298px;
    overflow: hidden;
  }
  .attachment-list-box-rest {
    overflow: auto;
    overflow-x: hidden;
    max-height: 200px;
  }
  .attachment-list {
    flex: 1;
    align-items: center;
  }
  .attachment-item {
    position: relative;
    cursor: pointer;
    display: flex;
    height: 32px;
    border: 1px solid #edeef2;
    padding: 5px 8px;
    box-sizing: border-box;
    border-radius: 4px;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    font-size: 14px;
    min-width: 65px;
    max-width: 185px;
    background-color: #fff;
    > div {
      display: flex;
      align-items: center;
    }
  }
  .el-dropdown {
    padding: 0 6px;
    cursor: pointer;
  }
  .attachment-item span {
    display: block;
    max-width: 280px;
    @include ellipsis;
  }
  .attachment-item > i {
    font-size: 12px;
    color: #c9cdd9;
    padding: 6px;
  }
  .attachment-item .iconicon_close_toast {
    margin-left: 8px;
    font-size: 16px;
    cursor: pointer;
  }
  .attachment-item:hover {
  }
  .downing-bix {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: #fff;
    padding: 0 10px;
    font-size: 12px;
    span {
      margin-left: 4px;
    }
  }
  .upload {
    /* width: 32px; */
    // height: 32px;
    // line-height: 32px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    span {
      margin-left: 9px;
    }
    &:hover {
      color: #509aff;
    }
  }
  .upload-demo {
    display: block;
    .iconicon_enlarge {
      margin-right: 20px;
    }
  }
  .upload > span {
    vertical-align: -2px;
  }
  .attachment-item-uploading {
    width: 100%;
    font-size: 12px;
    justify-content: flex-start;
    position: relative;
    .uploading-progress {
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0.4;
      .el-progress-bar,
      .el-progress-bar__outer,
      .el-progress-bar__inner {
        height: 100% !important;
        border-radius: 0;
      }
      .el-progress-bar__inner {
        background-color: #00b97e;
      }
    }
    span {
      margin-left: 4px;
    }
    i {
      font-size: 16px;
    }
  }
  .img-item {
    display: flex;
    align-items: center;
    // @include ellipsis;
  }
}
.custom-upload-only-value {
  padding-left: 8px;
}
</style>
